import { useId } from "react";
import { cn } from "@/lib/cn";

export interface CasillaProps {
  etiqueta: string;
  marcado: boolean;
  onCambio: (marcado: boolean) => void;
  ayuda?: string;
  deshabilitado?: boolean;
  /** La etiqueta sólo para lectores de pantalla (una casilla por fila de una tabla, ej. elegir fees en Honorarios). */
  etiquetaOculta?: boolean;
  className?: string;
}

/** Una casilla sí/no (preferencias, "Avisar por mail"). Para elegir varias opciones de una lista, `CheckList`. */
export function Casilla({ etiqueta, marcado, onCambio, ayuda, deshabilitado, etiquetaOculta, className }: CasillaProps) {
  const id = useId();
  return (
    <div className={cn("flex flex-col gap-1", className)}>
      <label className={cn("flex cursor-pointer items-center gap-3", deshabilitado && "cursor-not-allowed opacity-60")}>
        <input
          type="checkbox"
          className="size-4 accent-primario"
          checked={marcado}
          disabled={deshabilitado}
          aria-describedby={ayuda ? `${id}-ayuda` : undefined}
          onChange={(e) => onCambio(e.target.checked)}
        />
        <span className={etiquetaOculta ? "sr-only" : undefined}>{etiqueta}</span>
      </label>
      {ayuda && (
        <p id={`${id}-ayuda`} className="pl-7 text-chico text-texto-suave">
          {ayuda}
        </p>
      )}
    </div>
  );
}
